<template>
  <v-container class="no-margins" v-if="elements && elements.length">
    <v-expansion-panels v-for="(element, i) in elements" :key="i" class="progressbar mt-n2">
      <v-expansion-panel hide-actions class="panelsWithSpaces">
        <v-expansion-panel-header
          expand-icon="$sl-arrow-down"
          v-bind:class="{ active: Number(element.isApproved) }"
        >
          <v-row align="center" class="spacer" no-gutters>
            <!-- <v-col cols="2">
              <v-icon class="icon checked" size="14px" v-if="element.isApproved">$sl-save-filled</v-icon>            
            </v-col>-->
            <v-col class="subtitle-1 text-uppercase" cols="12">
              {{ element.name }}
              <v-icon v-if="element.isApproved==true" class="complete">$sl-completed</v-icon>

              <progressLinear
                :value="getPercentage(element.numSubElementsFinished, element.numSubElementsRequired)"
              ></progressLinear>
            </v-col>
          </v-row>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-container class="pt-0">
            <template v-if="isInstructor">
              <p
                class="mb-4"
                v-if="!(element.numSubElementsRequired &&  element.numSubElementsFinished && Number(element.numSubElementsRequired)<=Number(element.numSubElementsFinished))"
              >{{ $t('ebook.education-paneltext4-apprentice')}}</p>
              <ul>
                <li
                  v-for="(item, index) in element.bookSubElements.filter( function(e) {
                  return isApproved(e) === false})"
                  :key="index"
                >
                  <!-- <p>{{ $t('ebook.education-paneltext2-apprentice', {msg1: index + " ", msg2: item + " "})}}</p> -->
                  <p>
                    {{apprenticeName + " " + $t('ebook.education-paneltext3-instructor')}}
                    <i>{{item.name}}.</i>
                  </p>
                </li>
                <li
                  v-if="element.numSubElementsRequired &&  element.numSubElementsFinished && Number(element.numSubElementsRequired)<=Number(element.numSubElementsFinished)"
                >
                  <p>{{ apprenticeName + " " + $t('ebook.education-paneltext1-instructor', {msg1: element.numSubElementsFinished || '0'})}}</p>
                </li>
                <li v-else>
                  <p>{{ apprenticeName + " " + $t('ebook.education-paneltext1-2-instructor', {msg1: (Number(element.numSubElementsRequired)-Number(element.numSubElementsFinished)) || '0'})}}</p>
                </li>
              </ul>
            </template>
            <template v-else>
              <p
                class="mb-4"
                v-if="!(element.numSubElementsRequired &&  element.numSubElementsFinished && Number(element.numSubElementsRequired)<=Number(element.numSubElementsFinished))"
              >{{ $t('ebook.education-paneltext4-apprentice-2', {
                apprenticeFirstName: apprenticeName
              })}}</p>
              <ul class="pt-2 pl-0">
                <!-- <li>{{ $t('ebook.education-paneltext2-apprentice', {msg1: countSubElements(element) + "?", msg2: element.numSubElementsRequired + "?"})}}</li> -->
                <!-- <li v-for="(item, index) in element.bookSubElements" :key="index">  -->
                <li
                  v-for="(item, index) in uniqBy(element.bookSubElements.filter( function(e) {
                    return isApproved(e) === false}), 'name')"
                  :key="index"
                  :style="{ listStyle: 'none' }"
                >
                  <!-- <p>{{ $t('ebook.education-paneltext2-apprentice', {msg1: index + " ", msg2: item + " "})}}</p> -->
                  <p>- <i>{{item.name}}</i></p>
                </li>
                <li
                  v-if="element.numSubElementsRequired && element.numSubElementsFinished && Number(element.numSubElementsRequired)<=Number(element.numSubElementsFinished)"
                  :style="{ listStyle: 'none' }"
                >
                  <p>{{ $t('ebook.education-paneltext1-apprentice', {msg1: element.numSubElementsFinished || '0'})}}</p>
                </li>
                <li 
                  v-else
                  :style="{ listStyle: 'none' }"
                >
                  <br />
                  <p>
                    {{ $t('ebook.education-paneltext1-3-apprentice', {
                      apprenticeFirstName: apprenticeName,
                      msg1: (Number(element.numSubElementsRequired)-Number(element.numSubElementsFinished)) || '0'})
                    }}
                  </p>
                </li>
              </ul>
            </template>

            <p class="pt-6">
              <a
                href="#"
                @click.prevent="clickElementInfo(element)"
              >{{ $t('ebook.education-paneltext7') }}</a>
              <!-- -TODO add the correct site path-->
            </p>
            <v-divider class="fullwidth-17 mt-5 mb-1"></v-divider>
            <v-row class="no-gutters">
              <v-col cols="8" md="10" lg="11"></v-col>
              <v-col cols="4" md="2" lg="1" class="smallTitle align-end">
                <div>{{ $t('ebook.subtitle3') }}</div>
                <div>{{ $t('ebook.subtitle') }}</div>
                <div>{{ $t('ebook.subtitle2') }}</div>
              </v-col>
            </v-row>

            <div v-for="(item, key) in element.bookSubElements" :key="key">
              <template class="d-flex" v-if="item.isApproved == false">
                <v-row class="element-row no-gutters">
                  <v-col cols="8" md="10" lg="11" class="d-flex">
                    <div class="itemName">{{item.name}}</div>
                    <v-icon class="ml-1 mt-2" @click="clickInfo(item, element.name)">$sl-info</v-icon>
                  </v-col>

                  <v-col cols="4" md="2" lg="1" class="smallTitle">
                    <div></div>
                    <div>
                      <v-icon v-if="item.maxInstructorSkillEstimatedLevel ==1">$sl-ebook-lvl1</v-icon>
                      <v-icon v-else-if="item.maxInstructorSkillEstimatedLevel ==2">$sl-ebook-lvl2</v-icon>
                      <v-icon v-else-if="item.maxInstructorSkillEstimatedLevel ==3">$sl-ebook-lvl3</v-icon>
                      <v-icon v-else-if="item.maxInstructorSkillEstimatedLevel ==4">$sl-ebook-lvl4</v-icon>
                      <v-icon v-else></v-icon>
                    </div>
                    <div>
                      <v-icon v-if="item.requiredLevel==1">$sl-ebook-lvl1</v-icon>
                      <v-icon v-else-if="item.requiredLevel==2">$sl-ebook-lvl2</v-icon>
                      <v-icon v-else-if="item.requiredLevel==3">$sl-ebook-lvl3</v-icon>
                      <v-icon v-else-if="item.requiredLevel==4">$sl-ebook-lvl4</v-icon>
                      <v-icon v-else></v-icon>
                    </div>
                  </v-col>
                </v-row>
              </template>
              <template v-else>
                <v-row class="element-row no-gutters active">
                  <v-col cols="8" md="10" lg="11" class="d-flex">
                    <div class="itemName">{{item.name}}</div>
                    <v-icon class="ml-1 mt-2" @click="clickInfo(item, element.name)">$sl-info</v-icon>
                  </v-col>

                  <v-col cols="4" md="2" lg="1" class="smallTitle">
                    <div>
                      <v-icon>$sl-completed</v-icon>
                    </div>
                    <div>
                      <v-icon v-if="item.maxInstructorSkillEstimatedLevel ==1">$sl-ebook-lvl1</v-icon>
                      <v-icon v-else-if="item.maxInstructorSkillEstimatedLevel ==2">$sl-ebook-lvl2</v-icon>
                      <v-icon v-else-if="item.maxInstructorSkillEstimatedLevel ==3">$sl-ebook-lvl3</v-icon>
                      <v-icon v-else-if="item.maxInstructorSkillEstimatedLevel ==4">$sl-ebook-lvl4</v-icon>
                      <v-icon v-else>$sl-ebook-lvl2</v-icon>
                    </div>
                    <div>
                      <v-icon v-if="item.requiredLevel==1">$sl-ebook-lvl1</v-icon>
                      <v-icon v-else-if="item.requiredLevel==2">$sl-ebook-lvl2</v-icon>
                      <v-icon v-else-if="item.requiredLevel==3">$sl-ebook-lvl3</v-icon>
                      <v-icon v-else-if="item.requiredLevel==4">$sl-ebook-lvl4</v-icon>
                      <v-icon v-else></v-icon>
                    </div>
                  </v-col>
                </v-row>
              </template>
            </div>

            <!-- <v-card flat class="ma-0 pa-0">
              <div v-for="(item, key) in element.bookSubElements" :key="key">
                <! -- <v-divider :key="key" v-if="key != 0 && item.finished < Number('100')"></v-divider> 
                <div class="d-flex" v-if="item.isApproved == false"></div>

                <div class="itemSection active" v-else>
                  <v-icon class="icon checked" size="14px">$sl-save-filled</v-icon>

                  <div class="content">
                    <div>{{item.name}}</div>
                    <div>
                      <v-icon size="18px" @click="$emit('modalToogle', item)">$sl-info-small-filled</v-icon>
                    </div>
                  </div>
                  <div class="d-flex pl-2">
                    <div>
                      <v-icon class="icon skill-level">$sl-save-filled</v-icon>
                    </div>
                    <div>
                      <v-icon class="icon skill-level">$sl-save-filled</v-icon>
                    </div>
                  </div>
                </div>
              </div>
            </v-card>-->
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import progressLinear from '@/components/Common/ProgressLinear'
import filter from 'lodash/filter'
import countBy from 'lodash/countBy'
import uniqBy from 'lodash/uniqBy'

// @group Common
// ElementExpansionPanel component
export default {
  name: 'ElementExpansionPanel',

  props: {
    // Books element props
    elements: Array,
    // is instructor boolean
    isInstructor: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `false`
      default: false
    },
    // apprentice name
    apprenticeName: {
      // `string`
      type: String,
      // The default value is: `''`
      default: ''
    }
  },
  components: {progressLinear},
  data: () => ({}),

  created() {},

  watch: {},

  computed: {},

  filters: {},
  methods: {

    uniqBy,
    /**
     * @vuese
     * Used to show info for the book
     */
    clickInfo(item, parentName) {
      item.parentName = parentName
      // Fire books
      // @arg The argument is a object representing book
      this.$emit('modalToogle', item)
    },
    /**
     * @vuese
     * Used to show element info for the book
     */
    clickElementInfo(item) {
      // Fire books
      // @arg The argument is a object representing book
      this.$emit('elementModalToogle', item)
    },
    /**
     * @vuese
     * Used to check if an  element is approved or not which returns a boolean
     */
    isApproved(val) {
      if (val) {
        //dont show if it isn't required
        if (val.isRequired == false) return true
        if (val.maxInstructorSkillEstimatedLevel && val.requiredLevel) {
          if (val.maxInstructorSkillEstimatedLevel >= val.requiredLevel) return true
        }
      }
      return false
    },
    /**
     * @vuese
     * Used to count all approved subelements
     */
    countSubElements(element) {
      const h = countBy(filter(element.bookSubElements, ['isApproved', false]), 'requiredLevel')
      return h
    },
    /**
     * @vuese
     * Used to get percentage between two values
     */
    getPercentage(v1, v2) {
      var value = 0
      if (Number(v2) && v2 > 0) {
        return (v1 / v2) * 100
      } else return value
    }
  }
}
</script>

